<template>
    <div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
        <table class="table simple-table table-striped table-sm mb-0 table-bordered" style="font-size:0.8em;">
            <thead class="thead-dark">
            <tr>
                <th class="report-record" scope="col">{{$lang('ID')}}</th>
                <th class="report-record" scope="col">{{$lang('Nr zadania')}}</th>
                <th class="report-record" scope="col" style="min-width: 100px">{{$lang('Data zgłoszenia')}}</th>
                <th class="report-record" scope="col">{{$lang('Data oceny')}}</th>
                <th class="report-record" scope="col">{{$lang('Czas reakcji')}}</th>
                <th class="report-record" scope="col">{{$lang('Data realizacji')}}</th>
                <th class="report-record" scope="col">{{$lang('Status')}}</th>
                <th class="report-record" scope="col">{{$lang('Czas rozwiązania')}}</th>
            </tr>
            </thead>
            <tbody>

            <tr v-if="pagination.total === 0" class="table-light">
                <th colspan="8">{{$lang('Brak zgłoszeń.')}}</th>
            </tr>

            <template v-else v-for="(task, index) in pagination.data">

                <tr v-if="index ===0 || task.criterion !== pagination.data[index-1].criterion">
                    <th colspan="7">
                        <div class="form-row">
                            <div class="col-3">{{task.criterionName}}</div>
                            <div class="col-3">{{$lang('Liczba zgłoszeń:&nbsp;')+criteria[task.criterionName].amount}}</div>
                            <div class="col-3">
                                <span>{{$lang('Średni czas reakcji:&nbsp;')}}</span>
                                <span v-if="criteria[task.criterionName].reactionAvg !== null">{{criteria[task.criterionName].reactionAvg}}</span>
                                <span v-else>{{$lang('brak')}}</span>
                            </div>
                            <div class="col-3">
                                <span>{{$lang('Średni czas rozwiązania:&nbsp;')}}</span>
                                <span v-if="criteria[task.criterionName].resolveAvg !== null">{{criteria[task.criterionName].resolveAvg}}</span>
                                <span v-else>{{$lang('brak')}}</span>
                            </div>
                        </div>
                    </th>
                </tr>

                <tr>
                    <td class="report-record" :data-title="$lang('ID')"><a :href="'/task/' + task.id">{{task.id}}</a>
                    </td>
                    <td class="report-record" :data-title="$lang('Nr zadania')">
                        <a :href="jira_link + task.jira_id" target="_blank" v-if="task.jira_id"> {{task.jira_id}} </a>
                        <a v-else-if="task.ptd_id" :href="ptd_link + task.ptd_id" target="_blank">{{task.ptd_id}}</a>
                        <span v-else> - </span>
                    </td>
                    <td class="report-record"
                        :data-title="$lang('Data zgłoszenia')">{{task.created_at_showable}}
                    </td>
                    <td class="report-record"
                        :data-title="$lang('Data oceny')">{{task.evaluate_date_showable}}
                    </td>
                    <td class="report-record"
                        :data-title="$lang('Czas reakcji')">{{task.reactionTime}}
                    </td>
                    <td class="report-record"
                        :data-title="$lang('Data realizacji')">{{task.implementation_date_showable}}
                    </td>
                    <td class="report-record"
                        :data-title="$lang('Status')">
                        <span :class="'badge badge-'+project_badge_prefix+task.status">{{task.statusName}}</span>
                    </td>
                    <td class="report-record"
                        :data-title="$lang('Czas rozwiązania')">{{task.resolveTime}}
                    </td>
                </tr>
            </template>

            </tbody>
        </table>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1) + pagination.total"
        ></pagination-component>
    </div>
</template>

<script>
    export default {
        name: 'reaction-time-table',
        props: {
            pagination: Object,
            criteria: Object,
            jira_link: String,
            ptd_link: String,
            project_badge_prefix: String,
        },
    }
</script>
